import { Link, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Field, Form, Formik, useFormik } from "formik";
import config from "../../config/config";
import { Tabs, Tab } from "react-bootstrap";
import Select from "react-select";
import Loader from "../Loader/Loader";
import { event } from "jquery";
import { toastWarn } from "../../common/Toast";
// import Loader from "../../components/Loader/Loader";

const Deliveriescard = ({ callback, salesDeliveryDetails, salesdeliverydata }) => {
  console.log(salesDeliveryDetails, "new410");
  const paramObject = useParams();
  const token = localStorage.getItem("Token");
  const Id = localStorage.getItem("ID");

  const [localValues, setLocalValues] = useState({});

  const [formValues, setFormValues] = useState({
    ID: 0,
    SaleId: 0,
    DeliveryEmployee: "",
    Trackingno: "",
    ExpectedProcessing: "",
    ExpectedDelivery: "",
    DeliveryComment: "",
    Status: "",
    CategoryId: "",
    Duration: "",
    LocationId: "",
    ExpectedPickUp: "",
    FirstName: "",
    LastName: "",
    PhoneNumber: "",
    EMail: "",
    contactPreference: 0,
    Address1: "",
    Address1: "",
    City: "",
    State: "",
    Zip: "",
    Country: "",
    DeliveryFees: salesDeliveryDetails?.DeliveryFees ? salesDeliveryDetails?.DeliveryFees: "",
    ShippingZone: "",
    Taxgroup: "",
    homenumber: "",
  });

  console.log(formValues, "410501");

  const [loading, setLoading] = useState(false);
  const [statusDropdown, setStatusDropdown] = useState([]);
  const [categoryDropdown, setCategoryDown] = useState([]);
  const [locationDropdown, setLocationDropdown] = useState([]);
  const [durationDropdown, setDurationDropdown] = useState([]);
  const [dateTime, setDateTime] = useState("");
  const [deliverydateTime, setDeliveryDateTime] = useState("");
  const [expectedpickup, setExpectedPickUp] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [deliveryemployeeDropdown, setDeliveryemployeeDropdown] = useState([]);

  const [status, setStatus] = useState(0);
  const [deliveryEmployee, setDeliveryEmployee] = useState(0);
  const [categoryId, setCategoryId] = useState(0);
  const [locationId, setLocationId] = useState(0);
  const [durationValue, setDuration] = useState(0);
  const [ispickup, setIspickup] = useState(0);
  const [taxDropdown, setTaxDropdown] = useState([]);
  const [taxDropdownValue, setTaxDropdownValue] = useState("");
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // const formatPhoneNumber = (value) => {
  //   const cleaned = ("" + value).replace(/\D/g, "");

  //   const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  //   if (match) {
  //     return `${match[1]}-${match[2]}-${match[3]}`;
  //   }

  //   return value;
  // };

  useEffect(() => {
    axios
      .get(`${config.generalBaseUrl}/generals/taxclassdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setTaxDropdown(res.data.ResponseData);
        // setLoading(false);

        return res;
      });
    setLocationId(localStorage.getItem("Location"));
  }, []);

  let statusOptions = [];
  const statusDropDownData = statusDropdown.map((u, i) => {
    statusOptions[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  let employeeOptions = [];
  const employeeDropDownData = deliveryemployeeDropdown.map((u, i) => {
    employeeOptions[i] = {
      label: u.Name,
      value: u.Id,
    };
  });

  let categoryOptions = [];
  const categoryDropDownData = categoryDropdown.map((u, i) => {
    categoryOptions[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  let locationOptions = [];
  const locationDropDownData = locationDropdown.map((u, i) => {
    locationOptions[i] = {
      label: u.Name,
      value: u.Id,
    };
  });

  let durationOptions = [];
  const durationDropDownData = durationDropdown.map((u, i) => {
    durationOptions[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  const handleInputdeliveryClick = () => {
    const now = new Date();
    const formattedDateTime = now.toISOString().slice(0, 16);
    if (paramObject.id === undefined) {
      const x = { ...localValues, deliveryDateTime: formattedDateTime };
      setLocalValues(x);
      localStorage.setItem("DeliveryDraft", JSON.stringify(x));
    }
    setDeliveryDateTime(formattedDateTime);
  };

  const handleDatedeliveryTimeChange = (event) => {
    setDeliveryDateTime(event.target.value);
    if (paramObject.id === undefined) {
      const x = { ...localValues, deliveryDateTime: event.target.value };
      setLocalValues(x);
      localStorage.setItem("DeliveryDraft", JSON.stringify(x));
    }
  };

  useEffect(() => {
    if (paramObject?.id === undefined) {
      if (salesDeliveryDetails !== undefined) {
        const draftFromLocalStorage = JSON.parse(
          localStorage.getItem("DeliveryDraft")
        );

        const updatedLocalValues = {
          ...localValues,
          deliveryFees: draftFromLocalStorage?.deliveryFees !== undefined
          ? draftFromLocalStorage?.deliveryFees
          : 0,
          salesDeliveryDetails:
            draftFromLocalStorage?.salesDeliveryDetails !== undefined
              ? draftFromLocalStorage.salesDeliveryDetails
              : salesDeliveryDetails,
        };
        setLocalValues(updatedLocalValues);
        localStorage.setItem(
          "DeliveryDraft",
          JSON.stringify(updatedLocalValues)
        );
      }
    }
  }, [paramObject, salesDeliveryDetails]);

  const handleInputClick = () => {
    const now = new Date();
    const formattedDateTime = now.toISOString().slice(0, 16);
    if (paramObject.id === undefined) {
      const x = { ...localValues, dateTime: formattedDateTime };
      setLocalValues(x);
      localStorage.setItem("DeliveryDraft", JSON.stringify(x));
    }
    setDateTime(formattedDateTime);
  };

  const handleDateTimeChange = (event) => {
    setDateTime(event.target.value);

    // console.log(event.target.value, "dateTime")
    if (paramObject.id === undefined) {
      const x = { ...localValues, dateTime: event.target.value };
      setLocalValues(x);
      localStorage.setItem("DeliveryDraft", JSON.stringify(x));
    }
  };

  const [mappedItem, setMappedItem] = useState([]);
  const handleTaxDropdown = (event) => {
    if (paramObject?.id === undefined) {
      const x = {
        ...localValues,
        taxDropdownValue: Number(event.target.value),
      };
      setLocalValues(x);
      localStorage.setItem("DeliveryDraft", JSON.stringify(x));
    }
    setTaxDropdownValue(event.target.value);
    setLoading(true);
    axios
      .get(
        `${config.generalBaseUrl}/generals/taxclassfindbyid?taxclassid=${event.target.value}`,

        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          const response = res.data.ResponseData;
          const mappedReceivingItems = response.map((item) => {
            const mappedItem = {
              TaxName: item.Name,
              TaxPercent: parseInt(item.Percent),
              type: "deliveryTax",
              TaxItemID: "",
              TaxVariationID: "",
            };

            return mappedItem;
          });
          setMappedItem(mappedReceivingItems);
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          setLoading(false);
        } else {
          setLoading(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleExpectedClick = () => {
    const now = new Date();
    const formattedDateTime = now.toISOString().slice(0, 16);
    setExpectedPickUp(formattedDateTime);
  };

  const handleExpectedChange = (event) => {
    setExpectedPickUp(event.target.value);
    if (paramObject.id === undefined) {
      const x = { ...localValues, expectedPickUp: event.target.value };
      setLocalValues(x);
      localStorage.setItem("DeliveryDraft", JSON.stringify(x));
    }
  };

  //status dropdown
  const handleDropdownData = (DeliveryData) => {
    // console.log(DeliveryData,"DeliveryData")
    axios
      .get(`${config.employeesBaseUrl}/employees/usersdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        // console.log("employee", res);
        setDeliveryemployeeDropdown(res.data.ResponseData);
        // setLoading(false);

        return res;
      });

    axios
      .get(`${config.salesconfigBaseUrl}/sales/deliverystatuslist`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setStatusDropdown(res.data.ResponseData);

        return res;
      });

    //category dropdown
    axios
      .get(`${config.deliveriesBaseUrl}/deliveries/categoriesfindall`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setCategoryDown(res.data.ResponseData);
        return res;
      });

    axios
      .get(`${config.priceRulesBaseUrl}/pricerules/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        // console.log(res);
        setLocationDropdown(res.data.ResponseData);
        // setLoading(false);
        return res;
      });

    axios
      .get(`${config.generalBaseUrl}/generals/durationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        // console.log(res);
        setDurationDropdown(res.data.ResponseData);
        // setLoading(false);
        return res;
      });
  };

  useEffect(() => {
    handleDropdownData();

    const finalobj ={
      ID: salesDeliveryDetails?.Saleid > 0 ? salesDeliveryDetails?.Id : 0,
      SaleId: salesDeliveryDetails?.Saleid,
      DeliveryEmployee:
        salesDeliveryDetails?.EmployeId > 0
          ? salesDeliveryDetails?.EmployeId
          : 0 || localValues?.deliveryEmployee,
      Trackingno:
        salesDeliveryDetails?.TranckingNumber || localValues?.trackingNumber,
      ExpectedProcessing:
        salesDeliveryDetails?.EstimatedShippingDate || localValues?.dateTime,
      ExpectedDelivery:
        salesDeliveryDetails?.EstimatedDeliveryDate ||
        localValues?.deliveryDateTime,
      DeliveryComment:
        salesDeliveryDetails?.Comments || localValues?.deliveryComment,
      Status: salesDeliveryDetails?.Status || localValues?.status,
      CategoryId: salesDeliveryDetails?.CategoryId || localValues?.category,
      Duration: salesDeliveryDetails?.Duration || localValues?.duration,
      LocationId: salesDeliveryDetails?.LocationId || localValues?.location,
      ExpectedPickUp: salesDeliveryDetails?.EstimatedDeliveryDate,
      FirstName:
        localValues?.salesDeliveryDetails?.FirstName ||
        salesDeliveryDetails?.FirstName,
      LastName:
        salesDeliveryDetails?.LastName ||
        localValues?.salesDeliveryDetails?.LastName,
      PhoneNumber:
        salesDeliveryDetails?.PhoneNumber ||
        localValues?.salesDeliveryDetails?.PhoneNumber,
      EMail:
        salesDeliveryDetails?.Email || localValues?.salesDeliveryDetails?.Email,
      contactPreference: salesDeliveryDetails?.ContactPrefrence,
      Address1:
        salesDeliveryDetails?.Address1 ||
        localValues?.salesDeliveryDetails?.Address1,
      Address2:
        salesDeliveryDetails?.Address2 ||
        localValues?.salesDeliveryDetails?.Address2,
      homenumber:
        salesDeliveryDetails?.homenumber ||
        localValues?.salesDeliveryDetails?.homenumber,
      City:
        salesDeliveryDetails?.City || localValues?.salesDeliveryDetails?.City,
      State:
        paramObject?.id !== undefined
          ? localValues?.salesDeliveryDetails?.State ||
            salesDeliveryDetails?.State
          : localValues?.salesDeliveryDetails?.StateProvince ||
            salesDeliveryDetails?.StateProvince,
      Zip: localValues?.salesDeliveryDetails?.Zip || salesDeliveryDetails?.Zip,
      Country:
        localValues?.salesDeliveryDetails?.Country ||
        salesDeliveryDetails?.Country,
      DeliveryFees:
        salesDeliveryDetails?.DeliveryFees === undefined
          ? salesDeliveryDetails?.DeliveryFees
          : salesDeliveryDetails?.DeliveryFees || localValues.deliveryFees,
      ShippingZone:
        salesDeliveryDetails?.Shippingzoneid === undefined
          ? 0
          : salesDeliveryDetails?.Shippingzoneid,
      Taxgroup:
        salesDeliveryDetails?.Taxclassid === undefined
          ? 0
          : salesDeliveryDetails?.Taxclassid,
    };

    console.log(salesDeliveryDetails, "finalobj")
    console.log(finalobj, "finalobj")

    setFormValues(finalobj);


    if (paramObject.id !== undefined) {
      setStatus(salesDeliveryDetails?.Status);
      setDeliveryEmployee(salesDeliveryDetails?.EmployeId);
      setCategoryId(salesDeliveryDetails?.CategoryId);
      setLocationId(salesDeliveryDetails?.LocationId);
      setDuration(salesDeliveryDetails?.Duration);
      setSelectedOption(salesDeliveryDetails?.ContactPrefrence);
      setIspickup(salesDeliveryDetails?.Ispickup);
    }

    if (salesDeliveryDetails?.EstimatedShippingDate != undefined) {
      const estimatedShippingDate = new Date(
        salesDeliveryDetails?.EstimatedShippingDate
      );
      setDateTime(estimatedShippingDate.toISOString().slice(0, 16));
    }

    if (salesDeliveryDetails?.EstimatedDeliveryDate != undefined) {
      const estimatedDeliveryDate = new Date(
        salesDeliveryDetails?.EstimatedDeliveryDate
      );
      if (salesDeliveryDetails?.Ispickup == 1) {
        setExpectedPickUp(estimatedDeliveryDate.toISOString().slice(0, 16));
      } else {
        setDeliveryDateTime(estimatedDeliveryDate.toISOString().slice(0, 16));
      }
    }
  }, [salesDeliveryDetails, localValues]);

  const handleChangecheck = (event) => {
    // console.log(event.target.name);
    const { value } = event.target;

    if (paramObject.id === undefined) {
      const x = {
        ...localValues,
        salesDeliveryDetails: {
          ...localValues.salesDeliveryDetails,
          selectedOption: event?.target?.value,
        },
      };
      setLocalValues(x);
      localStorage.setItem("DeliveryDraft", JSON.stringify(x));
    }

    if (value == 1) {
      setSelectedOption(1);
    } else if (value == 2) {
      setSelectedOption(2);
    } else if (value == 3) {
      setSelectedOption(3);
    }
  };

  const handleSubmit = (values) => {
    console.log(values.homenumber  , "154258")
    if (values.homenumber < 0) {
      toastWarn("fill home Number First");
      return;
  }
  
    // localStorage.removeItem("DeliveryDraft")
    let DelivriesData = {
      Id: values.ID,
      Saleid: values.SaleId != undefined ? values.SaleId : 0,
      EmployeId: localValues?.deliveryEmployee || deliveryEmployee, // values.DeliveryEmployee,
      Status: localValues?.status || status, //values.Status,
      CategoryId: categoryId != undefined ? categoryId : 0, // values.CategoryId,
      Duration: localValues?.duration || durationValue, // values.Duration,
      LocationId: locationId === undefined ? 0 : locationId, // values.LocationId,
      FirstName: values.FirstName,
      LastName: values.LastName,
      Email: values.EMail,
      PhoneNumber: values.PhoneNumber,
      ContactPrefrence: selectedOption != undefined ? selectedOption : 0,
      Address1: values.Address1,
      Address2: values.Address2,
      homenumber: values.homenumber,
      City: values.City,
      State: values.State,
      Zip: values.Zip,
      Country: values.Country,
      TranckingNumber: values.Trackingno,
      Commesetitemnts: values.DeliveryComment,
      EstimatedShippingDate: dateTime,
      EstimatedDeliveryDate: ispickup == 1 ? expectedpickup : deliverydateTime,
      DeliveryFees: values.DeliveryFees || salesDeliveryDetails?.DeliveryFees,
      Shippingzoneid:
        values.ShippingZone != undefined ? values.ShippingZone : 0,
      Taxclassid: values.Taxgroup != undefined ? values.Taxgroup : 0,
      Loginuserid: Id,
      Ispickup: ispickup != undefined ? ispickup : 1,

      Isdelivery: 1,
    };

    callback(DelivriesData, mappedItem);

    // setMappedItem([]);
  };

  const handleCancelClick = () => {
    localStorage.removeItem("dataAfterDelivery");
    // localStorage.removeItem("DeliveryDraft");

    const draftFromLocalStorage = JSON.parse(
      localStorage.getItem("DeliveryDraft")
    );

    const updatedLocalValues = {
      deliveryFees: 0,
      salesDeliveryDetails: {}
    };
    setLocalValues(updatedLocalValues);
    localStorage.setItem(
      "DeliveryDraft",
      JSON.stringify(updatedLocalValues)
    );

    setStatus(0);
    setDeliveryEmployee(0);
    setCategoryId(0);
    setLocationId(0);
    setDuration(0);
    setDeliveryDateTime(null);
    setDateTime(null);
    setExpectedPickUp(null);
    setIspickup(0);

    setFormValues({
      ID: 0,
      SaleId: 0,
      DeliveryEmployee: "",
      Trackingno: "",
      ExpectedProcessing: "",
      ExpectedDelivery: "",
      DeliveryComment: "",
      Status: "",
      CategoryId: "",
      Duration: "",
      LocationId: "",
      ExpectedPickUp: "",
      FirstName: "",
      LastName: "",
      PhoneNumber: "",
      EMail: "",
      contactPreference: 0,
      Address1: "",
      Address1: "",
      City: "",
      State: "",
      Zip: "",
      Country: "",
      DeliveryFees: salesdeliverydata?.DeliveryFees ? salesdeliverydata?.DeliveryFees : "",
      ShippingZone: "",
      Taxgroup: "",
    });

    let CancelDelivery = { CancelDelivery: true };

    callback("CancelDelivery", mappedItem);
  };

  const handleChangeTable = (pValue) => {
    if (pValue == "methodInstorePickup") {
      setIspickup(1);

      if (paramObject.id === undefined) {
        const x = {
          ...localValues,
          Ispickup: 1,
        };
        setLocalValues(x);
        localStorage.setItem("DeliveryDraft", JSON.stringify(x));
      }
    } else {
      setIspickup(0);
      if (paramObject.id === undefined) {
        const x = {
          ...localValues,
          Ispickup: 0,
        };
        setLocalValues(x);
        localStorage.setItem("DeliveryDraft", JSON.stringify(x));
      }
    }
  };

  useEffect(() => {
    if (paramObject.id === undefined) {
      const savedData = localStorage.getItem("DeliveryDraft");
      if (savedData) {
        const parsedData = JSON.parse(savedData);
        setLocalValues(parsedData);
        // setDeliveryEmployee(parsedData.deliveryEmployee)
        setFormValues({
          ...formValues,
          DeliveryEmployee: parsedData?.deliveryEmployee,
          LocationId: parsedData?.location,
          Status: parsedData?.status,
          Duration: parsedData?.duration,
          Trackingno: parsedData?.trackingNumber,
          DeliveryComment: parsedData?.deliveryComment,
          DeliveryFees: parsedData?.deliveryFees,
          CategoryId: parsedData?.category,
          deliveryDateTime: parsedData?.deliveryDateTime,
          dateTime: parsedData?.dateTime,
          expectedPickUp: parsedData?.expectedPickUp,
        });
        setDeliveryDateTime(parsedData?.deliveryDateTime);
        setExpectedPickUp(parsedData?.expectedPickUp);
        setDateTime(parsedData?.dateTime);
        setCategoryId(parsedData?.category);
        setTaxDropdownValue(parsedData?.taxDropdownValue);
        setSelectedOption(parsedData?.salesDeliveryDetails?.selectedOption);
      }
    }
  }, []);

  return (
    <>
      <Loader loading={loading} />
      <div
        className="modal fade"
        show={show}
        onHide={handleClose}
        id="DeliveriesModal"
        tabIndex={-1}
        aria-labelledby="upset"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-body">
              <button
                type="button"
                className="close float-end"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
              <Formik
                {...salesDeliveryDetails}
                initialValues={formValues}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ values, errors, touched, handleChange, handleBlur }) => (
                  <Form>
                    <Field
                      type="hidden"
                      className="form-control"
                      id="ID"
                      name="ID"
                      value={values.ID}
                    />
                    <Field
                      type="hidden"
                      className="form-control"
                      id="SaleId"
                      name="SaleId"
                      value={values.SaleId}
                    />

                    <Tabs
                      defaultActiveKey="method"
                      id="form-tabs"
                      className="mb-4"
                    >
                      <Tab eventKey="method" title="Delivery Method">
                        <div className="row">
                          <div className="col-12">
                            <div className="card">
                              <div
                                className="card-header"
                                style={{ "text-align": "left" }}
                              >
                                <Tabs
                                  defaultActiveKey="methoddelivery"
                                  id="form-tabs1"
                                  className="mb-4"
                                  defaultIndex={1}
                                  onSelect={(index) => handleChangeTable(index)}
                                >
                                  <Tab
                                    eventKey="methoddelivery"
                                    title="Delivery"
                                  >
                                    <div
                                      className="row"
                                      style={{ "text-align": "left" }}
                                    >
                                      <div className="form-group row">
                                        <label className="col-form-label col-md-3">
                                          Delivery Employee
                                        </label>
                                        <div className="col-md-9">
                                          <Select
                                            onChange={(event) => {
                                              setDeliveryEmployee(event?.value);
                                              if (
                                                paramObject.id === undefined
                                              ) {
                                                const x = {
                                                  ...localValues,
                                                  deliveryEmployee:
                                                    event?.value,
                                                };
                                                setLocalValues(x);
                                                localStorage.setItem(
                                                  "DeliveryDraft",
                                                  JSON.stringify(x)
                                                );
                                              }
                                            }}
                                            value={employeeOptions.find(
                                              (option) =>
                                                option?.value ==
                                                formValues.DeliveryEmployee
                                            )}
                                            options={employeeOptions}
                                            id="DeliveryEmployee"
                                            name="DeliveryEmployee"
                                            className="custom-search-select"
                                            backspaceRemovesValue={false}
                                            controlShouldRenderValue={true}
                                            isClearable={true}
                                          />
                                        </div>
                                      </div>
                                      <div className="form-group row">
                                        <label className="col-form-label col-md-3">
                                          Tracking Number
                                        </label>
                                        <div className="col-md-9">
                                          <Field
                                            type="text"
                                            name="Trackingno"
                                            id="Trackingno"
                                            className="form-control form-control-sm"
                                            onBlur={handleBlur}
                                            onChange={(event) => {
                                              handleChange(event);
                                              const trackingNumberValue =
                                                event.target.value;
                                              // Save the tracking number value to localStorage
                                              if (
                                                paramObject.id === undefined
                                              ) {
                                                const x = {
                                                  ...localValues,
                                                  trackingNumber:
                                                    trackingNumberValue,
                                                };
                                                setLocalValues(x);
                                                localStorage.setItem(
                                                  "DeliveryDraft",
                                                  JSON.stringify(x)
                                                );
                                              }
                                            }}
                                          />
                                        </div>
                                      </div>
                                      <div className="form-group row">
                                        <label className="col-form-label col-md-3 form-label">
                                          Expected Processing
                                        </label>
                                        <div className="col-md-9">
                                          <Field
                                            type="datetime-local"
                                            className="form-control"
                                            onClick={handleInputClick}
                                            onChange={handleDateTimeChange}
                                            value={dateTime}
                                            id="ExpectedProcessing"
                                            name="ExpectedProcessing"
                                          />
                                        </div>
                                      </div>
                                      <div className="form-group row">
                                        <label className="col-form-label col-md-3 form-label">
                                          Expected Delivery
                                        </label>
                                        <div className="col-md-9">
                                          <Field
                                            type="datetime-local"
                                            className="form-control"
                                            onClick={handleInputdeliveryClick}
                                            onChange={
                                              handleDatedeliveryTimeChange
                                            }
                                            value={deliverydateTime}
                                            id="ExpectedDelivery"
                                            name="ExpectedDelivery"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </Tab>
                                  <Tab
                                    eventKey="methodInstorePickup"
                                    title="Instore Pickup"
                                  >
                                    <div className="row">
                                      <div className="form-group row">
                                        <label className="col-form-label col-md-3 form-label">
                                          Expected Pick-Up
                                        </label>
                                        <div className="col-md-9">
                                          <Field
                                            type="datetime-local"
                                            className="form-control"
                                            onClick={handleExpectedClick}
                                            onChange={handleExpectedChange}
                                            value={expectedpickup}
                                            id="ExpectedPickUp"
                                            name="ExpectedPickUp"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </Tab>
                                </Tabs>

                                <div className="row">
                                  <div className="col-md-12">
                                    <div className="form-group row">
                                      <label className="col-form-label col-md-3">
                                        Delivery Comment
                                      </label>
                                      <div className="col-md-9">
                                        <Field
                                          as="textarea"
                                          name="DeliveryComment"
                                          id="DeliveryComment"
                                          className={`form-control`}
                                          rows={5}
                                          cols={5}
                                          onBlur={handleBlur}
                                          onChange={(event) => {
                                            handleChange(event);
                                            if (paramObject.id === undefined) {
                                              const x = {
                                                ...localValues,
                                                deliveryComment:
                                                  event?.target?.value,
                                              };
                                              setLocalValues(x);
                                              localStorage.setItem(
                                                "DeliveryDraft",
                                                JSON.stringify(x)
                                              );
                                            }
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group row">
                                      <label className="col-form-label col-md-3">
                                        Status
                                      </label>
                                      <div className="col-md-9">
                                        <Select
                                          // onChange={handleChange}
                                          onChange={(event) => {
                                            console.log(
                                              event.value,
                                              "875410501"
                                            );
                                            setStatus(event.value);
                                            setFormValues((prevFormValues) => ({
                                              ...prevFormValues,
                                              Status: event?.value,
                                            }));
                                            // const x = { ...localValues, status: event?.value };
                                            // setLocalValues(x);
                                            // localStorage.setItem("DeliveryDraft", JSON.stringify(x))
                                            if (paramObject.id === undefined) {
                                              const x = {
                                                ...localValues,
                                                status: event?.value,
                                              };
                                              setLocalValues(x);
                                              localStorage.setItem(
                                                "DeliveryDraft",
                                                JSON.stringify(x)
                                              );
                                            }
                                          }}
                                          value={statusOptions.find(
                                            (option) =>
                                              option?.value == formValues.Status
                                          )}
                                          options={statusOptions}
                                          id="Status"
                                          name="Status"
                                          className="custom-search-select"
                                          backspaceRemovesValue={false}
                                          controlShouldRenderValue={true}
                                          isClearable={true}
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group row">
                                      <label className="col-form-label col-md-3">
                                        Category
                                      </label>
                                      <div className="col-md-9">
                                        <Select
                                          onChange={(event) => {
                                            setCategoryId(event.value);
                                            if (paramObject.id === undefined) {
                                              const x = {
                                                ...localValues,
                                                category: event?.value,
                                              };
                                              setLocalValues(x);
                                              localStorage.setItem(
                                                "DeliveryDraft",
                                                JSON.stringify(x)
                                              );
                                            }
                                          }}
                                          value={categoryOptions.find(
                                            (option) =>
                                              option?.value ==
                                              formValues?.CategoryId
                                          )}
                                          options={categoryOptions}
                                          id="CategoryId"
                                          name="CategoryId"
                                          className="custom-search-select"
                                          backspaceRemovesValue={false}
                                          controlShouldRenderValue={true}
                                          isClearable={true}
                                        />
                                      </div>
                                    </div>

                                    <div className="form-group row">
                                      <label className="col-form-label col-md-3">
                                        Duration
                                      </label>
                                      <div className="col-md-9">
                                        <Select
                                          onChange={(event) => {
                                            setDuration(event.value);
                                            if (paramObject.id === undefined) {
                                              const x = {
                                                ...localValues,
                                                duration: event?.value,
                                              };
                                              setLocalValues(x);
                                              localStorage.setItem(
                                                "DeliveryDraft",
                                                JSON.stringify(x)
                                              );
                                            }
                                          }}
                                          value={durationOptions.find(
                                            (option) =>
                                              option?.value ==
                                              formValues.Duration
                                          )}
                                          options={durationOptions}
                                          id="Duration"
                                          name="Duration"
                                          className="custom-search-select"
                                          backspaceRemovesValue={false}
                                          controlShouldRenderValue={true}
                                          isClearable={true}
                                        />
                                      </div>
                                    </div>
                                    <div className="form-group row">
                                      <label className="col-form-label col-md-3">
                                        Location
                                      </label>
                                      <div className="col-md-9">
                                        <Select
                                          onChange={(event) => {
                                            setLocationId(event.value);
                                            if (paramObject.id === undefined) {
                                              const x = {
                                                ...localValues,
                                                location: event?.value,
                                              };
                                              setLocalValues(x);
                                              localStorage.setItem(
                                                "DeliveryDraft",
                                                JSON.stringify(x)
                                              );
                                            }
                                          }}
                                          value={locationOptions.find(
                                            (option) =>
                                              option?.value ==
                                              formValues.LocationId
                                          )}
                                          options={locationOptions}
                                          id="LocationId"
                                          name="LocationId"
                                          className="custom-search-select"
                                          backspaceRemovesValue={false}
                                          controlShouldRenderValue={true}
                                          isClearable={true}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                      <Tab eventKey="address" title="Delivery Address">
                        <div className="row" style={{ "text-align": "left" }}>
                          <div className="col-6">
                            <div className="form-group row">
                              <label className="col-form-label col-md-4">
                                {" "}
                                First Name
                              </label>
                              <div className="col-md-8">
                                <Field
                                  type="text"
                                  className="form-control"
                                  onChange={(event) => {
                                    handleChange(event);
                                    if (paramObject.id === undefined) {
                                      const x = {
                                        ...localValues,
                                        salesDeliveryDetails: {
                                          ...localValues.salesDeliveryDetails,
                                          FirstName: event?.target?.value,
                                        },
                                      };
                                      setLocalValues(x);
                                      localStorage.setItem(
                                        "DeliveryDraft",
                                        JSON.stringify(x)
                                      );
                                    }
                                  }}
                                  id="FirstName"
                                  name="FirstName"
                                />
                              </div>
                            </div>
                            <div className="form-group row">
                              <label className="col-form-label col-md-4">
                                {" "}
                                Last Name{" "}
                              </label>
                              <div className="col-md-8">
                                <Field
                                  type="text"
                                  className="form-control"
                                  onChange={(event) => {
                                    handleChange(event);
                                    if (paramObject.id === undefined) {
                                      const x = {
                                        ...localValues,
                                        salesDeliveryDetails: {
                                          ...localValues.salesDeliveryDetails,
                                          LastName: event?.target?.value,
                                        },
                                      };
                                      setLocalValues(x);
                                      localStorage.setItem(
                                        "DeliveryDraft",
                                        JSON.stringify(x)
                                      );
                                    }
                                  }}
                                  id="LastName"
                                  name="LastName"
                                />
                              </div>
                            </div>
                            <div className="form-group row">
                              <label className="col-form-label col-md-4">
                                {" "}
                                Phone Number{" "}
                              </label>
                              <div className="col-md-8">
                                <Field
                                  type="text"
                                  className="form-control"
                                  onChange={(event) => {
                                    handleChange(event);
                                    if (paramObject.id === undefined) {
                                      const x = {
                                        ...localValues,
                                        salesDeliveryDetails: {
                                          ...localValues.salesDeliveryDetails,
                                        },
                                      };
                                      setLocalValues(x);
                                      localStorage.setItem(
                                        "DeliveryDraft",
                                        JSON.stringify(x)
                                      );
                                    }
                                  }}
                                  id="PhoneNumber"
                                  name="PhoneNumber"
                                />
                              </div>
                            </div>
                            <div className="form-group row">
                              <label className="col-form-label col-md-4">
                                {" "}
                                Email{" "}
                              </label>
                              <div className="col-md-8">
                                <Field
                                  type="text"
                                  className="form-control"
                                  onChange={(event) => {
                                    handleChange(event);
                                    if (paramObject.id === undefined) {
                                      const x = {
                                        ...localValues,
                                        salesDeliveryDetails: {
                                          ...localValues.salesDeliveryDetails,
                                          Email: event?.target?.value,
                                        },
                                      };
                                      setLocalValues(x);
                                      localStorage.setItem(
                                        "DeliveryDraft",
                                        JSON.stringify(x)
                                      );
                                    }
                                  }}
                                  id="EMail"
                                  name="EMail"
                                />
                              </div>
                            </div>
                            <div className="form-group row">
                              <label className="col-form-label col-md-4">
                                Address1
                              </label>
                              <div className="col-md-8">
                                <Field
                                  type="text"
                                  className="form-control"
                                  onChange={(event) => {
                                    handleChange(event);
                                    if (paramObject.id === undefined) {
                                      const x = {
                                        ...localValues,
                                        salesDeliveryDetails: {
                                          ...localValues.salesDeliveryDetails,
                                          Address1: event?.target?.value,
                                        },
                                      };
                                      setLocalValues(x);
                                      localStorage.setItem(
                                        "DeliveryDraft",
                                        JSON.stringify(x)
                                      );
                                    }
                                  }}
                                  id="Address1"
                                  name="Address1"
                                />
                              </div>
                            </div>
                            <div className="form-group row">
                              <label className="col-form-label col-md-4">
                                Address2
                              </label>
                              <div className="col-md-8">
                                <Field
                                  type="text"
                                  className="form-control"
                                  onChange={(event) => {
                                    handleChange(event);
                                    if (paramObject.id === undefined) {
                                      const x = {
                                        ...localValues,
                                        salesDeliveryDetails: {
                                          ...localValues.salesDeliveryDetails,
                                          Address2: event?.target?.value,
                                        },
                                      };
                                      setLocalValues(x);
                                      localStorage.setItem(
                                        "DeliveryDraft",
                                        JSON.stringify(x)
                                      );
                                    }
                                  }}
                                  id="Address1"
                                  name="Address2"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="form-group row">
                              <label className="col-form-label col-md-4">
                                {" "}
                                City{" "}
                              </label>
                              <div className="col-md-8">
                                <Field
                                  type="text"
                                  className="form-control"
                                  onChange={(event) => {
                                    handleChange(event);
                                    if (paramObject.id === undefined) {
                                      const x = {
                                        ...localValues,
                                        salesDeliveryDetails: {
                                          ...localValues.salesDeliveryDetails,
                                          City: event?.target?.value,
                                        },
                                      };
                                      setLocalValues(x);
                                      localStorage.setItem(
                                        "DeliveryDraft",
                                        JSON.stringify(x)
                                      );
                                    }
                                  }}
                                  id="City"
                                  name="City"
                                />
                              </div>
                            </div>
                            <div className="form-group row">
                              <label className="col-form-label col-md-4">
                                State/Province{" "}
                              </label>
                              <div className="col-md-8">
                                <Field
                                  type="text"
                                  className="form-control"
                                  onChange={(event) => {
                                    handleChange(event);
                                    if (paramObject.id === undefined) {
                                      const x = {
                                        ...localValues,
                                        salesDeliveryDetails: {
                                          ...localValues.salesDeliveryDetails,
                                          StateProvince: event?.target?.value,
                                        },
                                      };
                                      setLocalValues(x);
                                      localStorage.setItem(
                                        "DeliveryDraft",
                                        JSON.stringify(x)
                                      );
                                    }
                                  }}
                                  id="State"
                                  name="State"
                                />
                              </div>
                            </div>
                            <div className="form-group row">
                              <label className="col-form-label col-md-4">
                                {" "}
                                Zip
                              </label>
                              <div className="col-md-8">
                                <Field
                                  type="number"
                                  className="form-control"
                                  onChange={(event) => {
                                    handleChange(event);
                                    if (paramObject.id === undefined) {
                                      const x = {
                                        ...localValues,
                                        salesDeliveryDetails: {
                                          ...localValues.salesDeliveryDetails,
                                          Zip: event?.target?.value,
                                        },
                                      };
                                      setLocalValues(x);
                                      localStorage.setItem(
                                        "DeliveryDraft",
                                        JSON.stringify(x)
                                      );
                                    }
                                  }}
                                  id="Zip"
                                  name="Zip"
                                />
                              </div>
                            </div>
                            <div className="form-group row">
                              <label className="col-form-label col-md-4">
                                {" "}
                                Country{" "}
                              </label>
                              <div className="col-md-8">
                                <Field
                                  type="text"
                                  className="form-control"
                                  onChange={(event) => {
                                    handleChange(event);
                                    if (paramObject.id === undefined) {
                                      const x = {
                                        ...localValues,
                                        salesDeliveryDetails: {
                                          ...localValues.salesDeliveryDetails,
                                          Country: event?.target?.value,
                                        },
                                      };
                                      setLocalValues(x);
                                      localStorage.setItem(
                                        "DeliveryDraft",
                                        JSON.stringify(x)
                                      );
                                    }
                                  }}
                                  id="Country"
                                  name="Country"
                                />
                              </div>
                            </div>
                            <div className="form-group row">
                              <label className="col-form-label col-md-4">
                                Contact Preference
                              </label>
                              <div className="col-md-8">
                                <div className="form-check form-check-inline">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="phone"
                                    name="contactPreference"
                                    value="1"
                                    checked={selectedOption == "1"}
                                    onChange={handleChangecheck}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="phone"
                                  >
                                    {" "}
                                    Phone{" "}
                                  </label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="email"
                                    name="contactPreference"
                                    value="2"
                                    checked={selectedOption == "2"}
                                    onChange={handleChangecheck}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="email"
                                  >
                                    {" "}
                                    Email{" "}
                                  </label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="text"
                                    name="contactPreference"
                                    value="3"
                                    checked={selectedOption == "3"}
                                    onChange={handleChangecheck}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="text"
                                  >
                                    {" "}
                                    Text
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="form-group row">
                              <label className="col-form-label col-md-4">
                                Home Number
                              </label>
                              <div className="col-md-8">
                                <Field
                                  type="text"
                                  className="form-control"
                                  onChange={(event) => {
                                    handleChange(event);
                                    if (paramObject.id === undefined) {
                                      const x = {
                                        ...localValues,
                                        salesDeliveryDetails: {
                                          ...localValues.salesDeliveryDetails,
                                          homenumber: event?.target?.value,
                                        },
                                      };
                                      setLocalValues(x);
                                      localStorage.setItem(
                                        "homenumber",
                                        JSON.stringify(x)
                                      );
                                    }
                                  }}
                                  id="homenumber"
                                  name="homenumber"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                      <Tab eventKey="fees" title="Delivery Fees">
                        <div className="row" style={{ "text-align": "left" }}>
                          <div className="col-12">
                            <div className="form-group row">
                              <label className="col-form-label col-md-3">
                                {" "}
                                Delivery Fees{" "}
                              </label>
                              <div className="col-md-7">
                                <div class="input-group">
                                  <span class="input-group-text">$</span>
                                  <Field
                                    type="number"
                                    className="form-control"
                                    onChange={(e) => {
                                      handleChange(e);
                                      if (paramObject.id === undefined) {
                                        const x = {
                                          ...localValues,
                                          deliveryFees: e?.target?.value,
                                        };
                                        setLocalValues(x);
                                        localStorage.setItem(
                                          "DeliveryDraft",
                                          JSON.stringify(x)
                                        );
                                      }
                                    }}
                                    id="DeliveryFees"
                                    name="DeliveryFees"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="form-group row">
                              <label className="col-form-label col-md-3">
                                Shipping Zone
                              </label>
                              <div className="col-md-7">
                                <Field
                                  as="select"
                                  className="form-control"
                                  name="ShippingZone"
                                  id="ShippingZone"
                                  // value={StateSelected}
                                  onChange={(e) => {
                                    handleChange(e);
                                    if (paramObject.id === undefined) {
                                      const x = {
                                        ...localValues,
                                        deliveryFees: e?.target?.value,
                                      };
                                      setLocalValues(x);
                                      localStorage.setItem(
                                        "ShippingZone",
                                        JSON.stringify(x)
                                      );
                                    }
                                  }}
                                >
                                  <option value="0"> None </option>
                                </Field>
                              </div>
                            </div>
                            <div className="form-group row">
                              <label className="col-form-label col-md-3">
                                Tax group
                              </label>
                              <div className="col-md-7">
                                <Field
                                  as="select"
                                  className="form-control"
                                  onChange={(e) => handleTaxDropdown(e)}
                                  name="Taxgroup"
                                  // data-bs-dismiss="modal"
                                  value={taxDropdownValue}
                                  id="Taxgroup"
                                >
                                  <option value=""> None </option>
                                  {taxDropdown?.map((item) => {
                                    return (
                                      <option value={item.GROUP_ID}>
                                        {item.Name}
                                      </option>
                                    );
                                  })}
                                  {/* <option value="Taxes"> Taxes </option> */}
                                </Field>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                    </Tabs>
                    <div className="col-lg-12 justify-content-right">
                      <button
                        type="submit"
                        className="btn btn-primary btn-md me-1"
                        data-bs-dismiss="modal"
                      >
                        Save Delivery
                      </button>
                      <Link
                        to="#"
                        onClick={handleCancelClick}
                        className="btn btn-dark btn-md me-1"
                        data-bs-dismiss="modal"
                      >
                        Cancel Delivery
                      </Link>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Deliveriescard;
